import React from 'react';
import Auth from 'works/legacy/lib/auth';
import {
  defaultLoginRedirectPath,
  EntityTypeType,
} from 'works/legacy/lib/default-login-redirect-path';
import { AuthTemplateCentralizedContainer } from '@identity/components';
import { useRedirectPath } from '@identity/hooks/use-redirect-path';
import { randomAccountColor } from '@identity/services';
import { Navigate } from '@common/components';
import { useParams } from '@common/hooks';

export function SignInSuccessPage() {
  const {
    email: encodedEmail,
    ssoToken,
    entityType,
    membershipId,
  } = useParams<{
    email: string;
    ssoToken: string;
    entityType: EntityTypeType;
    membershipRole: string;
    membershipId: string;
  }>();

  const redirectPath = useRedirectPath();
  const email = decodeURIComponent(encodedEmail || '');

  const idsToken = ssoToken || '';

  const effectiveEntityType = entityType || 'Organization';

  const userState = {
    identityToken: idsToken,
    email,
    entityType: effectiveEntityType,
    membershipId: membershipId || '',
    name: 'loading',
    entityName: 'loading',
    path: redirectPath || defaultLoginRedirectPath(effectiveEntityType),
    color: randomAccountColor({ exclude: Auth.colorsBeingUsed() }),
  };

  Auth.store(userState);

  const shouldRedirect = Boolean(idsToken);

  return shouldRedirect ? (
    <AuthTemplateCentralizedContainer>
      <Navigate to={userState.path} />
    </AuthTemplateCentralizedContainer>
  ) : null;
}
